import educationalMaterials from './educational-materials';
import learningTrails from './learning-trails';
import sitFinance from './sit-finance';

export const Role = { educationalMaterials, learningTrails, sitFinance };
